import React from "react";
import { useGetClientFolderInfoQuery } from "./query.hotchoc.generated";
import { Link } from "react-router-dom";
import { customer } from "~/routes";
import { InfoLabel } from "./components/InfoLabel";

type ClientFolderInfoProps = {
  customerNumber: string;
};

export const ClientFolderInfo: React.FC<ClientFolderInfoProps> = ({
  customerNumber,
}) => {
  const { loading, error, data } = useGetClientFolderInfoQuery({
    variables: {
      input: { customerNumber },
    },
  });

  const customerData = data?.customers?.single;

  return loading ? (
    <>
      <InfoLabel>Loading info...</InfoLabel>
    </>
  ) : data && !error ? (
    <>
      <InfoLabel>
        <Link to={customer.toRoute(customerNumber).path}>
          <span>Customer Number: </span>
          {customerData?.number}
        </Link>
      </InfoLabel>
      <InfoLabel>
        <Link to={customer.toRoute(customerNumber).path}>
          <span>Customer Name: </span>
          {customerData?.name}
        </Link>
      </InfoLabel>
      <InfoLabel>
        <span>Customer address: </span>
        {customerData?.address1}
        <br />
        {customerData?.address2}
      </InfoLabel>
    </>
  ) : (
    <>
      <InfoLabel>Error fetching customer info</InfoLabel>
    </>
  );
};
